/**
 * 腾讯优量汇广告sdk封装
 * 由于sdk广告只能加载一次，无法重复渲染，用事件机制以及操作dom的方法，实现广告的异步主动渲染。
 * 用法：页面入口先加载好所有的广告，在需要的地方调用渲染函数。
 * 注意：由于banner广告的特殊性，你需要在成功回调中处理广告的位置样式，并在组件销毁时调用隐藏函数隐藏广告
 */
import platform from '@/platform'
/**
 *
 * @param {String} page 哪个页面，例如 home，answer
 */
export function loadTCAD(page) {
  if (!process.env.VUE_APP_serve) return
  window.TencentGDT = window.TencentGDT || []
  const ad = platform.TencentAd[page]
  window.TCAD_platform = ad
  if (!ad) return
  ad.forEach((item, index) => {
    const { placement_id, app_id, type } = item
    let template = {}
    if (type === 'banner') {
      const ele = document.createElement('div')
      ele.style.position = 'fixed'
      ele.style.left = '-1000px'
      ele.id = `TCAD` + index
      ele.className = `TCAD` + index
      document.querySelector('body').appendChild(ele)
      template = {
        placement_id: placement_id, // 广告位id，请从联盟平台广告位获取
        app_id: app_id,
        type: 'native', // 广告类型
        display_type: 'banner', // 广告播放类型: banner广告
        carousel: 3000, // 轮播时间，> 3000数字类型，否则轮播会被取消
        containerid: `TCAD` + index, // 广告容器
        onComplete: function(res) {
          if (res.ret === 0) {
            const detail = {
              index: index,
              res: res,
              type,
              containerid: `TCAD` + index
            }
            // 事件发布
            const event = new CustomEvent('TCAD', {
              detail
            })
            document.dispatchEvent(event)
            window.TCAD = window.TCAD || []
            window.TCAD[index] = detail
          }
        }
      }
    }
    if (type === 'native') {
      template = {
        app_id: app_id, // {String} - appid - 必填
        placement_id: placement_id, // {String} - 广告位id - 必填
        type: 'native', // {String} - 原生广告类型 - 必填
        muid_type: '1', // {String} - 移动终端标识类型，1：imei，2：idfa，3：mac号 - 选填
        muid: '******', // {String} - 加密终端标识，详细加密算法见API说明 -  选填
        count: 3, // {Number} - 拉取广告的数量，默认是3，最高支持10 - 选填
        onComplete: function(res) {
          if (res && res.constructor === Array) {
            // 原生模板广告位调用 window.TencentGDT.NATIVE.renderAd(res[0], 'containerId') 进行模板广告的渲染
            // res[0] 代表取广告数组第一个数据
            // containerId：广告容器ID

            const detail = {
              index: index,
              res: res,
              type
            }
            const event = new CustomEvent('TCAD', {
              detail
            })
            // 事件发布
            document.dispatchEvent(event)
            window.TCAD = window.TCAD || []
            window.TCAD[index] = detail
          } else {
            // 加载广告API，如广告回调无广告，可使用loadAd再次拉取广告
            // 注意：拉取广告频率每分钟不要超过20次，否则会被广告接口过滤，影响广告位填充率

            setTimeout(function() {
              window.TencentGDT.NATIVE.loadAd(placement_id)
            }, 3000)
          }
        }
      }
    }
    window.TencentGDT.push(template)
  })

  // H5 SDK接入全局只需运行一次
  setTimeout(() => {
    ;(function() {
      // var doc = document
      // var h = doc.getElementsByTagName('head')[0]
      // var s = doc.createElement('script')
      // s.async = true
      // s.src = '//qzs.qq.com/qzone/biz/res/i.js'
      // h && h.insertBefore(s, h.firstChild)
    })()
  }, 0)
}
/**
 内部渲染函数
 */
function render(detail, containerid, success) {
  const { res, type } = detail
  // Banner 移动dom
  if (type === 'banner') {
    const ad = document.querySelector(`#${detail.containerid}`)
    ad.style.left = 0
    ad.style.right = 0
    success(ad)
  }
  // 原声直接渲染
  if (type === 'native') {
    const randomItem = res[Math.floor(Math.random() * res.length)]
    window.TencentGDT.NATIVE.renderAd(randomItem, containerid)
    success()
  }
}
/**
 外部渲染接口：
 containerid: 容器
 index：广告索引，对应平台json中的索引
 success：成功回调
 */
export function renderTCAD({ containerid, index, success = () => false }) {
  if (window.TCAD) {
    let ad = window.TCAD[index]
    // 广告补位规则
    if (!ad && window.TCAD_platform) {
      const type = window.TCAD_platform[index].type
      const replaceAd = window.TCAD.filter(Boolean).find((i) => i.type === type)
      if (replaceAd) {
        window.TCAD[index] = replaceAd
      }
      ad = replaceAd
    }
    if (ad) {
      render(ad, containerid, success)
    }
    return
  }
  // 事件订阅,存在多次重复订阅的情况，可用函数节流，暂不予考虑
  document.addEventListener('TCAD', (e) => {
    if (e.detail.index === index) {
      render(e.detail, containerid, success)
    }
  })
}
/**
 * 隐藏广告接口，banner广告时需要
 * @param {Number} index 广告位
 */
export function hideTCAD(index) {
  if (window.TCAD && window.TCAD[index]) {
    const item = window.TCAD[index]
    if (item.type === 'banner') {
      const adEle = document.querySelector(`#${item.containerid}`)
      if (adEle) {
        adEle.style.left = '1000px'
      }
    }
  }
}
